const LOCAL_STORAGE_TOKEN = "token";

export function getCachedUserToken(): string | null {
  return window.localStorage.getItem(LOCAL_STORAGE_TOKEN);
}

export function setUserToken(token: string) {
  return window.localStorage.setItem(LOCAL_STORAGE_TOKEN, token);
}

export function removeCachedUserToken() {
  return window.localStorage.removeItem(LOCAL_STORAGE_TOKEN);
}
